import React from 'react';
import { X } from 'lucide-react';
import * as Dialog from '@radix-ui/react-dialog';

interface MobileMenuProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileMenu({ open, onOpenChange }: MobileMenuProps) {
  const scrollToContact = () => {
    onOpenChange(false);
    const contactForm = document.getElementById('contact-form');
    contactForm?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
    setTimeout(() => {
      const nameInput = document.getElementById('name') as HTMLInputElement;
      nameInput?.focus();
    }, 800);
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" />
        <Dialog.Content className="fixed inset-y-0 right-0 w-[80%] max-w-sm bg-white shadow-xl z-50 flex flex-col">
          <div className="flex items-center justify-between p-6 border-b">
            <Dialog.Title className="text-xl font-semibold">Menu</Dialog.Title>
            <Dialog.Close className="text-gray-500 hover:text-gray-700">
              <X className="h-6 w-6" />
            </Dialog.Close>
          </div>
          <div className="flex flex-col p-6 space-y-6">
            <a 
              href="#services" 
              className="text-lg hover:text-blue-600 transition"
              onClick={() => onOpenChange(false)}
            >
              Services
            </a>
            <a 
              href="#about" 
              className="text-lg hover:text-blue-600 transition"
              onClick={() => onOpenChange(false)}
            >
              About
            </a>
            <a 
              href="#contact" 
              className="text-lg hover:text-blue-600 transition"
              onClick={() => onOpenChange(false)}
            >
              Contact
            </a>
            <button 
              onClick={scrollToContact}
              className="w-full bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Get Started
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}